const isComponent = (prop) => {
    return typeof prop === 'object' && prop !== null && prop.hasOwnProperty('package');
};

export { isComponent };
//# sourceMappingURL=componentChecker.js.map
